import * as tslib_1 from "tslib";
import { HttpEventType, } from '@angular/common/http';
import { FileUploadService } from '@services/file.upload.service';
import { ODataService } from '@services/generics/odata.service';
import { filter } from 'rxjs/operators';
var BaseLicenseService = /** @class */ (function (_super) {
    tslib_1.__extends(BaseLicenseService, _super);
    function BaseLicenseService(http, mapper, _injector) {
        var _this = _super.call(this, http, mapper) || this;
        _this._injector = _injector;
        _this._endpoint = '';
        _this._fileUploadService = _this._injector.get(FileUploadService);
        return _this;
    }
    BaseLicenseService.prototype.uploadLicense = function (file) {
        var uploadEndpoint = this._endpoint + "/UiPath.Server.Configuration.OData.UploadLicense()";
        return this._fileUploadService
            .uploadFiles([file], uploadEndpoint)
            .pipe(filter(function (ev) { return ev.type === HttpEventType.Response; }));
    };
    BaseLicenseService.prototype.activateLicenseOnline = function (licenseKey, environment, email) {
        var payload = JSON.stringify({
            licenseKey: licenseKey,
            environment: environment,
            email: email,
        });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.ActivateLicenseOnline", payload);
    };
    BaseLicenseService.prototype.activateLicenseOffline = function (file) {
        return this._fileUploadService.uploadFiles([file], this._endpoint + "/UiPath.Server.Configuration.OData.ActivateLicenseOffline()");
    };
    BaseLicenseService.prototype.getLicenseOffline = function (licenseKey, environment, email) {
        var payload = JSON.stringify({
            licenseKey: licenseKey,
            environment: environment,
            email: email,
        });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.GetLicenseOffline", payload);
    };
    BaseLicenseService.prototype.updateLicenseOnline = function () {
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.UpdateLicenseOnline", null);
    };
    BaseLicenseService.prototype.deactivateLicenseOnline = function (tenantId) {
        var payload = JSON.stringify({
            tenantId: tenantId,
        });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.DeactivateLicenseOnline", payload);
    };
    BaseLicenseService.prototype.getDeactivateLicenseOffline = function (tenantId) {
        var payload = JSON.stringify({
            tenantId: tenantId,
        });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.GetDeactivateLicenseOffline", payload);
    };
    return BaseLicenseService;
}(ODataService));
export { BaseLicenseService };
